import api from './api';

const VAPID_PUBLIC_KEY = 'BDT3sQDeaJhvQHe_CrbmKifgygdtlppVCbDe7OAY7oobL5D5pnWIOYLy-bVPr30xJLqkHDRZcGVXVIwXLQloeGQ';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Register service worker
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.log('Push notifications not supported');
    return null;
  }
  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    console.log('✅ Service Worker registered');
    return registration;
  } catch (err) {
    console.error('Service Worker registration failed:', err);
    return null;
  }
}

// Request permission and subscribe
export async function subscribeToPush() {
  try {
    const registration = await registerServiceWorker();
    if (!registration) return false;

    // Check current permission
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Push notification permission denied');
      return false;
    }

    // Get VAPID key from backend (or use hardcoded)
    let vapidKey = VAPID_PUBLIC_KEY;
    try {
      const r = await api.get('/push/vapid-key');
      vapidKey = r.data.publicKey || VAPID_PUBLIC_KEY;
    } catch {}

    // Subscribe
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });

    // Save to backend
    await api.post('/push/subscribe', { subscription });
    console.log('✅ Push subscription saved');
    return true;
  } catch (err) {
    console.error('Push subscription error:', err);
    return false;
  }
}

// Check if already subscribed
export async function checkPushSubscription() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    return !!subscription;
  } catch {
    return false;
  }
}

// Unsubscribe
export async function unsubscribeFromPush() {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await api.post('/push/unsubscribe', { endpoint: subscription.endpoint });
      await subscription.unsubscribe();
    }
    return true;
  } catch {
    return false;
  }
}
